import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import CancellationPopup from "@irati/ui/src/CancellationPopup"
import {BlockRefresh, BlockNavigationActions} from "@irati/utils/history/routing"
import {injectIntl} from "@irati/utils/lang"

class OnLeaveRedemption extends Component {
  static propTypes = {
    unblockNavigation: PropTypes.func.isRequired,
    show: PropTypes.bool,
    block: PropTypes.bool,
    formatMessage: PropTypes.func.isRequired
  }
  static defaultProps = {
    block: false
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.show && this.props.show) {
      this.cancellation.popup.open()
    }
  }

  onLeave = () => {
    const {unblockNavigation} = this.props
    unblockNavigation(true)
  }

  onCancel = () => {
    const {unblockNavigation} = this.props
    unblockNavigation(false)
  }

  render() {
    const {block, formatMessage} = this.props

    return (
      <BlockRefresh block={block}>
        <CancellationPopup
          ref={(c) => { this.cancellation = c }}
          onConfirm={this.onLeave}
          onCancel={this.onCancel}
          headerBody={formatMessage({id: "perks.containers.onLeaveRedemption.cancellation.headerbody"})}
          cancelButtonText={formatMessage({id: "perks.containers.onLeaveRedemption.cancellation.cancelButtonText"})}
          confirmButtonText={formatMessage({id: "perks.containers.onLeaveRedemption.cancellation.leaveButtonText"})}
          cancelImage={formatMessage({id: "perks.components.cancellationPopUp.image"})} />
      </BlockRefresh>
    )
  }
}

const mapStateToProps = ({blockNavigation}) => {
  return {
    show: blockNavigation.show
  }
}

const actions = (dispatch) => {
  return {
    unblockNavigation: (bool) => dispatch(BlockNavigationActions.unblock(bool))
  }
}

export default injectIntl(connect(mapStateToProps, actions)(OnLeaveRedemption))
